import { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";

import "./UKMRVVoyages.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import { UKMRVOldVoyageColumnsData } from "../../../../../../constants/CustomTableHeaders";
import axiosHttp from "../../../../../../services/interceptor";
import UKMRVVoyagesNewVersion from "./UKMRVVoyagesNew";
import Loader from "../../../../../../common/Loader/Loader";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { ClaimType } from "../../../../../../constants/claims";

const UKMRVVoyages = () => {
	const { userHasClaim } = useContext(ClaimsContext);
	const [UKMRVData, setUKMRVDatav] = useState([]);
	const [loading, setLoading] = useState(false);
	const reportDetails = useSelector(
		(state) => state.reports.selectedReportDetails
	);

	const user = useSelector((state) => state.userInfo.userData);

	const alwaysColumns = UKMRVOldVoyageColumnsData?.filter(
		(column) => !column.condition
	);
	const conditionalColumns = UKMRVOldVoyageColumnsData?.filter(
		(column) => column.condition && userHasClaim(column.condition)
	);

	const staticColumns = [
		...alwaysColumns.slice(0, 8),
		...conditionalColumns.filter(
			(item) => item.accessorKey === "calcTimeAtSea"
		),
		...alwaysColumns.slice(8, 10),
		...conditionalColumns.filter(
			(item) => item.accessorKey === "calcDistanceTravelled"
		),
		...alwaysColumns.slice(10),
	];

	const fetchUKMRVVoyagesData = async () => {
		setLoading(true);
		try {
			const UKMRVVoyagesData = await axiosHttp({
				url: `api/Report/GetFuelEuMrvVoyages?childReportId=${reportDetails.ReportMstId}`,
				method: "GET",
			});
			if (UKMRVVoyagesData?.data?.data) {
				setLoading(false);
				setUKMRVDatav(UKMRVVoyagesData?.data?.data);
			} else if (UKMRVVoyagesData) {
				setLoading(false);
				setUKMRVDatav(UKMRVVoyagesData?.data);
			} else {
				setLoading(false);
				setUKMRVDatav([]);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		fetchUKMRVVoyagesData();
	}, []);

	return (
		<>
			{loading ? (
				<div className="loader">
					<Loader />
				</div>
			) : (
				<>
					{UKMRVData && UKMRVData?.reportView === "2.0" ? (
						<UKMRVVoyagesNewVersion
							data={UKMRVData?.voyageList}
							loading={loading}
						/>
					) : (
						UKMRVData &&
						UKMRVData?.length > 0 &&
						UKMRVData[0]?.reportView === "1.0" && (
							<div className="UKMRV-custom-table-container">
								<CustomTable
									columnsData={staticColumns}
									renderTableData={UKMRVData}
									customProps={{
										isLoading: loading,
										enableSort: false,
										enableToptoolbar: false,
									}}
								/>
							</div>
						)
					)}
				</>
			)}
		</>
	);
};

export default UKMRVVoyages;
